import { useLocation } from 'react-router-dom';

import { logMessage } from '@services/sentry-service';

const PageNotFound = () => {
  const location = useLocation();
  logMessage(`Could not find route ${location.pathname}`);

  return (
    <div>
      <h1>404 Error</h1>
      <h1>Page Not Found</h1>
    </div>
  );
};

export default PageNotFound;
